import { TreatmentCard } from "./TreatmentCard";
import type {
  PlayerInfo,
  WinningTreatmentInfo,
  TreatmentCard as TreatmentCardType,
} from "../types/game";

interface WinnerDisplayProps {
  winningInfo: WinningTreatmentInfo;
  players: PlayerInfo[];
}

export function WinnerDisplay({ winningInfo, players }: WinnerDisplayProps) {
  const winnerPlayer = players.find(
    (p) => p.player_id === winningInfo.player_id,
  );

  return (
    <div className="glass rounded-lg p-6 border-2 border-yellow-400">
      <h2 className="font-display text-3xl font-bold mb-4 text-yellow-400">
        Round Winner!
      </h2>
      <div className="bg-white/10 rounded-lg p-4">
        <p className="text-lg font-semibold mb-3">
          {winnerPlayer?.display_name} wins with:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          {winningInfo.submitted_cards
            .filter(
              (card): card is TreatmentCardType =>
                card.card_type === "TreatmentCard",
            )
            .map((card) => (
              <TreatmentCard key={card.card_id} card={card} />
            ))}
        </div>
        <p className="mt-3 text-green-400 font-semibold">Winner!</p>
      </div>
    </div>
  );
}
